import { AllSoakStyleResponse, AllTrimsResponse, CommonResponse, SoakStyleDto, SoakStyleRequest, SoakStyleResponse, TrimsResponse } from '@gtpl/shared-models/masters';

import { Body, Controller, Post, Req } from '@nestjs/common';

import { SoakService } from './soaks.service';
import { SoaksDTO } from './dto/soaks.dto';
import { SoakStylesRequest } from './dto/soaks.request';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';


@ApiTags('soaks')
@Controller('soaks')
export class SoaksController {
    constructor(
        private soakService: SoakService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}


  @Post('/createSoaks')
  async createSoaks(@Body() soaksDTO:SoaksDTO,isUpdate:boolean=false, @Req() request:Request): Promise<SoakStyleResponse> {
      try {
       return await this.soakService.createSoaks(soaksDTO,false,request);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(SoakStyleResponse, error);
     }
   }

   
     @Post('/getallsoakstyleData')
     async getAllSoaks(): Promise<CommonResponse> {
         try {
             return await this.soakService.getAllSoaks();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(SoakStyleResponse, error);
         }
     }
 
        @Post('/activateOrDeactivateSoakStyle')
        @ApiBody({type:SoakStylesRequest})
        async activateOrDeactivateSoakStyle(@Body() soakReq: any): Promise<SoakStyleResponse> {
          
            try {
                return await this.soakService.activateOrDeactivateSoakStyle(soakReq);
            } catch (err) {
                return this.applicationExceptionHandler.returnException(SoakStyleResponse, err);
            }
        }
   
        
     @Post('/UpdateSoakstyle')
     async UpdateSoakstyle(@Body() soaksDTO:SoaksDTO, @Req() request:Request): Promise<SoakStyleResponse> {
         try {
          return await this.soakService.createSoaks(soaksDTO,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(SoakStyleResponse, error);
        }
        
      }


      @Post('/getAllSoakStyleDropDown')
      async getAllSoakStyleDropDown():Promise<CommonResponse>{
         try {
             return await this.soakService.getAllSoaksDropDown();
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CommonResponse, err);
         }
      }
 
     
       
       @Post('/getSoaksInfoById')
     async getSoaksInfoById(@Body() soakReq: SoakStyleDto):Promise<CommonResponse>{
        try {
            return await this.soakService.getSoaksInfoById(soakReq.soakstyleId);
        } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
      }
     

    @Post('/getAllSoakStyles')
    async getAllSoakStyles(): Promise<CommonResponse>{
       
        try{
            return await this.soakService.getAllSoakStyles()
        }
        catch(err){
            return err
        }
    }
      
    @Post('/updateSoaksStyles')
    async updateSoaksStyles(@Body() soakStyleDto: any, isUpdate: boolean = false): Promise<AllSoakStyleResponse> {
      try {
        return await this.soakService.updateSoaksStyles(soakStyleDto);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(AllSoakStyleResponse, error)
      }
  
  }
}
